import React, { useState } from 'react';
import './Contact.css';
import {
  Typography,
  TextField,
  Grid,
  Container,
  Button,
  Modal,
  Fade,
  Backdrop,
  Box,
} from '@mui/material';
import MapIcon from '@mui/icons-material/Map';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import axios from 'axios';

export default function Contact() {
  const [open, setOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formSubmitStatusMessage, setSubmitMessage] = useState({
    status: true,
    Title: '',
    Message: '',
  });

  const [formData, setFormData] = useState({
    Name: '',
    Phone: '',
    Email: '',
    Message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await axios.post(
        'https://script.google.com/macros/s/AKfycbzkO13Rb2TO6za67bqde7ztJejXjvdB_cxMn0DozCgXypyJaiGZJGDQ0oN7o-p8aySkWQ/exec',
        formData,
        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
      );
      setSubmitMessage({
        status: true,
        Title: 'Success!',
        Message: "Thank you for contacting us — we’ll get back to you shortly.",
      });
    } catch {
      setSubmitMessage({
        status: false,
        Title: 'Error!',
        Message: 'Something went wrong. Please try again later.',
      });
    } finally {
      setIsSubmitting(false);
      setFormData({ Name: '', Phone: '', Email: '', Message: '' });
      setOpen(true);
    }
  };

  const handleClose = () => setOpen(false);

  return (
    <section className="contact-section">
      <Container maxWidth="lg">
        <Typography variant="h3" align="center" className="contact-title">
          Get in Touch
        </Typography>
        <Typography align="center" className="contact-subtitle">
          We’re here to answer any questions and provide the best cleaning solutions for you.
        </Typography>

        <Grid container spacing={5} alignItems="stretch" className="contact-wrapper">
          {/* Left Info Section */}
          <Grid item xs={12} md={5} className="contact-info">
            <div className="info-card">
              <Typography variant="h5" className="contact-heading">
                Contact Information
              </Typography>

              <div className="contact-item">
                <MapIcon className="contact-icon" />
                <Typography>
                  U-66, Rukmani Tower, Upadhyay Block, Shakarpur, Laxmi Nagar, Delhi-110092
                </Typography>
              </div>

              <div className="contact-item">
                <LocalPhoneIcon className="contact-icon" />
                <div>
                  <Typography><a href="tel:+91-9953614486">+91 99536 14486</a></Typography>
                  {/* <Typography><a href="tel:+919711775486">+91 97117 75486</a></Typography> */}
                </div>
              </div>

              <div className="contact-item">
                <EmailIcon className="contact-icon" />
                <Typography>
                  <a href="mailto:info@Saafsafai53@gmail.com">Saafsafai53@gmail.com</a>
                </Typography>
              </div>
            </div>
          </Grid>

          {/* Right Form Section */}
          <Grid item xs={12} md={7}>
            <div className="form-card">
              <Typography variant="h5" className="contact-heading">
                Leave Your Message
              </Typography>
              <form className="contact-form" onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Name"
                      variant="outlined"
                      name="Name"
                      value={formData.Name}
                      onChange={handleChange}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Phone"
                      variant="outlined"
                      name="Phone"
                      value={formData.Phone}
                      onChange={handleChange}
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Email"
                      variant="outlined"
                      name="Email"
                      value={formData.Email}
                      onChange={handleChange}
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Message"
                      variant="outlined"
                      name="Message"
                      multiline
                      rows={4}
                      value={formData.Message}
                      onChange={handleChange}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} textAlign="center">
                    <Button
                      type="submit"
                      variant="contained"
                      className="contact-btn"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? 'Sending...' : 'Send Message'}
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </div>
          </Grid>
        </Grid>

        {/* Modal */}
        <Modal
          open={open}
          onClose={handleClose}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{ backdrop: { timeout: 500 } }}
        >
          <Fade in={open}>
            <Box className="contact-modal">
              <Typography
                variant="h6"
                fontWeight="bold"
                color={formSubmitStatusMessage.status ? 'success.main' : 'error.main'}
              >
                {formSubmitStatusMessage.Title}
              </Typography>
              <Typography sx={{ mt: 2, mb: 3 }}>
                {formSubmitStatusMessage.Message}
              </Typography>
              <Button variant="contained" sx={{ backgroundColor: '#f0542d' }} onClick={handleClose}>
                OK
              </Button>
            </Box>
          </Fade>
        </Modal>
      </Container>
    </section>
  );
}
